import React from 'react';
import {Link}  from "react-router-dom";

export default function Shop({isUser}) {
  return (
    <div className='shop page'>
        <h2 className='heading'>Explore Our Categories</h2>
        <div className='category'>
            <Link to={isUser ? "/category/clothes" : "/login"}><div className='womens cate'>
                <div>Clothings</div>
            </div></Link>
            <Link to={isUser ? "/category/accessories" : "/login"}><div className='accesories cate'>
                <div>Accessories</div>
            </div></Link>
            <Link to={isUser ? "/category/devices" : "/login"}><div className='devices cate'>
                <div>Devices</div>
            </div></Link>
            <Link to={isUser ? "/category/gaming" : "/login"}><div className='gaming cate'>
                <div>Gaming</div>
            </div></Link>
            <Link to={isUser ? "/category/supermarket" : "/login"}><div className='supermarket cate'>
                <div>Supermarket</div>
            </div></Link>
        </div>
    </div>
  )
}
